import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/lp-game.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/v2/grader/GraderApp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/v2/grader/ScrollToScan.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LPMagnetMount"] */ "/vercel/path0/src/components/v2/LPMagnetMount.tsx");
